import { reduce, each, indexOf, trim, endsWith, startCase } from 'lodash';

export const tokens = [
  {
    label: 'Opportunity Info',
    value: 'opportunity',
    sources: ['opportunity'],
    values: [
      {
        label: 'Opportunity Id',
        value: '{OpportunityId}',
      },
      {
        label: 'Opportunity Name',
        value: '{OpportunityName}',
      },
      {
        label: 'Opportunity Amount',
        value: '{OpportunityAmount}',
      },
      {
        label: 'Opportunity Close Date',
        value: '{OpportunityCloseDate}',
      },
      {
        label: 'Opportunity Outcome',
        value: '{OpportunityOutcome}',
      },
      {
        label: 'Opportunity Type',
        value: '{OpportunityType}',
      },
      {
        label: 'Opportunity Products',
        value: '{OpportunityProducts}',
      },
      {
        label: 'Salesforce Opportunity URL',
        value: '{OpportunityURL}',
      },
    ],
  },
  {
    label: 'Account Info',
    value: 'account',
    values: [
      {
        label: 'Account Id',
        value: '{AccountId}',
      },
      {
        label: 'Account Name',
        value: '{AccountName}',
      },
      {
        label: 'Account Industry',
        value: '{AccountIndustry}',
      },
      {
        label: 'Salesforce Account URL',
        value: '{AccountURL}',
      },
    ],
  },
  {
    label: 'Opportunity Owner Info',
    value: 'owner',
    sources: ['opportunity'],
    values: [
      {
        label: 'Owner Id',
        value: '{OpportunityOwnerId}',
      },
      {
        label: 'Owner First Name',
        value: '{OpportunityOwnerFirstName}',
      },
      {
        label: 'Owner Last Name',
        value: '{OpportunityOwnerLastName}',
      },
      {
        label: 'Owner Full Name',
        value: '{OpportunityOwnerFullName}',
      },
      {
        label: 'Owner Role',
        value: '{OpportunityOwnerRole}',
      },
      {
        label: 'Owner Profile',
        value: '{OpportunityOwnerProfile}',
      },
      {
        label: 'Salesforce Owner URL',
        value: '{OpportunityOwnerURL}',
      },
    ],
  },
  {
    label: 'Account Owner Info',
    value: 'accountOwner',
    sources: ['account'],
    values: [
      {
        label: 'Owner Id',
        value: '{AccountOwnerId}',
      },
      {
        label: 'Owner First Name',
        value: '{AccountOwnerFirstName}',
      },
      {
        label: 'Owner Last Name',
        value: '{AccountOwnerLastName}',
      },
      {
        label: 'Owner Full Name',
        value: '{AccountOwnerFullName}',
      },
      {
        label: 'Owner Role',
        value: '{AccountOwnerRole}',
      },
      {
        label: 'Owner Profile',
        value: '{AccountOwnerProfile}',
      },
      {
        label: 'Salesforce Owner URL',
        value: '{AccountOwnerURL}',
      },
    ],
  },
  {
    label: 'Submitted Contacts',
    value: 'submitted-contacts',
    types: ['summary'],
    restrict: true,
    values: [
      {
        label: 'Submitted Contacts',
        value: '{SubmittedContacts}',
      },
    ],
  },
  {
    label: 'Terminated Contacts',
    value: 'terminated-contacts',
    restrict: true,
    types: ['alert'],
    values: [
      {
        label: 'Terminated Contacts',
        value: '{TerminatedContacts}',
      },
    ],
  },
  {
    label: 'Feedback Request URL',
    value: 'requestURL',
    values: [
      {
        value: '{FeedbackRequestURL}',
        label: 'Feedback Request URL',
        restrict: true,
      },
      {
        value: '{FeedbackRequestURLRaw}',
        label: 'Feedback Request URL Raw',
      },
    ],
  },
  {
    label: 'Exclude Feedback Request',
    value: 'excludeRequest',
    types: ['reminder', 'exclusion', 'summary'],
    values: [
      {
        value: '{ExcludeDealURL}',
        label: 'Exclude Feedback Request URL',
        restrict: true,
        sources: ['opportunity'],
      },
      {
        value: '{ExcludeDealURLRaw}',
        label: 'Exclude Feedback Request URL Raw',
        sources: ['opportunity'],
      },
      {
        value: '{OpportunityExclusionReason}',
        label: 'Opportunity Exclusion Reason',
        sources: ['opportunity'],
      },
      {
        value: '{ExcludeAccountURL}',
        label: 'Exclude Feedback Request URL',
        restrict: true,
        sources: ['account'],
      },
      {
        value: '{ExcludeAccountURLRaw}',
        label: 'Exclude Feedback Request URL Raw',
        sources: ['account'],
      },
      {
        value: '{AccountExclusionReason}',
        label: 'Account Exclusion Reason',
        sources: ['account'],
      },
    ],
  },
];

function isValidItem(item, type, source) {
  const validGroupType = (item.types && indexOf(item.types, type) >= 0) || !item.types;
  const validGroupSource = (item.sources && indexOf(item.sources, source) >= 0) || !item.sources;
  return validGroupType && validGroupSource;
}

export function getFilteredTokens(type, source = 'opportunity') {
  return reduce(tokens, (items, tokenGroup) => {
    if (isValidItem(tokenGroup, type, source)) {
      const subTokens = reduce(tokenGroup.values, (subItems, token) => {
        if (isValidItem(token, type, source)) {
          const rawValue = trim(token.value, '{}');
          if (endsWith(rawValue, 'URL')) {
            let content = startCase(rawValue.replace('URL', ''));
            if (content === 'Opportunity' || content === 'Account' || content === 'OpportunityOwner') {
              content = `${content} details`;
            }
            subItems.push({
              ...token,
              editorValue: `{${rawValue}}${content}{/${rawValue}}`,
            });
          } else {
            subItems.push(token);
          }
        }
        return subItems;
      }, []);

      if (subTokens.length) {
        items.push({
          ...tokenGroup,
          values: subTokens,
        });
      }
    }
    return items;
  }, []);
}

export function getTranslatedTokens() {
  return reduce(tokens, (items, tokenGroup) => {
    each(tokenGroup.values, (val) => {
      items[val.value] = val.label;
    });
    return items;
  }, {});
}

export default {
  tokens,
};
